import styled, { css } from "styled-components"

import colors, { hexToRgba } from "../../utils/colors"
import { basicButtonStyles, transparentButtonStyles } from "./button"

export interface ButtonProps {
  transparent?: boolean
  inverted?: boolean
  "data-gtm-cta": string
}

const ExternalLinkButton = styled.a<ButtonProps>`
  display: inline-block;
  color: ${colors.teal};
  background-color: ${colors.teal};
  padding: 0px 20px;
  border: none;
  border-radius: 10px;
  outline: 0;
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s ease;
  height: 42px;
  line-height: 42px;

  ${props => (props.transparent ? transparentButtonStyles : basicButtonStyles)}
  ${props =>
    props.transparent && props.inverted ? `border-color: ${colors.gray10};` : ""}

  &:disabled {
    cursor: auto;
    pointer-events: none;
    color: ${hexToRgba(colors.dark, 0.3)};
    background-color: ${hexToRgba(colors.dark, 0.1)};
  }
  &.error {
    background-color: ${colors.red};
  }
`

export default ExternalLinkButton
